import { Tree, TreeData } from '@livv/models';
import { useMemo } from 'react';

const usePathTitles = (path: string[], bookData: TreeData, bookMeta: Omit<Tree, 'content'>) =>
    useMemo(() => {
        return path.map((_, index) => {
            const subpath = path.slice(0, index + 1);

            try {
                const node = bookData.getNode(subpath);

                if (!node) {
                    return null;
                }

                const typo = bookData.getLocalNodeTypography(
                    subpath,
                    bookMeta.language,
                    bookMeta.dummyLevel,
                );

                return { subpath, title: node.title, typo };
            } catch (e) {
                console.error(e);

                return null;
            }
        });
    }, [path, bookData, bookMeta.language, bookMeta.dummyLevel]);

const useLegitextMetaDescription = (isLegitext: boolean, pathTitles: Array<{ title: string }>) =>
    useMemo(() => {
        if (!isLegitext) {
            return '';
        }

        return pathTitles
            .filter(Boolean)
            .map(({ title }) => {
                const parts = title.split(':');

                if (parts.length > 1) {
                    return parts[1].trim();
                }

                return title;
            })
            .join(' / ');
    }, [isLegitext, pathTitles]);

export { usePathTitles, useLegitextMetaDescription };
